/**
 * Parseo de montos escritos a la argentina.
 * "675.430" → 675430 (punto = miles) · "675,43" → 675.43 (coma = decimales)
 * "1.234.567,89" → 1234567.89 · "1500" → 1500 · "1500.50" → 1500.5
 */
export function parseMoneyAr(raw: string): number {
  const t = String(raw || '').replace(/[$\s]/g, '').trim();
  if (!t) return NaN;
  if (t.includes(',')) {
    // La coma es el separador decimal; los puntos son de miles
    return parseFloat(t.replace(/\./g, '').replace(',', '.'));
  }
  // Solo puntos: si vienen agrupando de a 3 son miles ("675.430", "1.234.567")
  if (/^\d{1,3}(\.\d{3})+$/.test(t)) {
    return parseFloat(t.replace(/\./g, ''));
  }
  return parseFloat(t);
}
